<template>
  <div class="login-container">
    <section class="login-main">
      <div class="logo-img"><img src="../../assets/login.svg" alt="" /></div>
      <login-form />
    </section>
    <footer class="login-footer">
      <span>Copyright@芜湖安得智联科技有限公司 版权所有 </span>
      <a href="https://beian.miit.gov.cn" class="provision" target="_blank"><span>皖ICP备2021008228号-3</span></a>

      <!-- <a href="http://beian.miit.gov.cn" class="provision" target="_blank"><span>皖ICP备2021008228号-12A</span></a>
      <a href="https://static.annto.com/res/webInfo/service.html" class="provision" target="_blank"
        ><span>服务条款</span></a
      >
      <a href="https://static.annto.com/res/webInfo/privacy.html" class="provision" target="_blank"
        ><span>隐私政策</span></a
      > -->
    </footer>
  </div>
</template>

<script setup lang="ts">
import LoginForm from './components/loginForm.vue';
import { removeStorage } from '@/utils/index';
removeStorage();
</script>

<style lang="less">
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: linear-gradient(225deg, rgba(250, 252, 255, 0) 0%, #e9eff6 100%);
}
.login-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: center center / cover no-repeat;
  // 登录背景：WebP 优先 + JPG 降级（image-set）
  // 不支持 image-set 的浏览器使用下一行 jpg；支持则自动选 webp（体积更小、2560 宽）
  background-image: url('@/assets/login_bg.jpg');
  background-image: image-set(
    url('@/assets/login_bg.webp') type('image/webp'),
    url('@/assets/login_bg.jpg') type('image/jpeg')
  );

  .login-main {
    position: absolute;
    right: 20%;
    top: 50%;
    transform: translateY(-50%);
    height: 567px;
    z-index: 1;

    .logo-img {
      display: block;
      width: 100%;
      height: 70px;
      display: flex;
      justify-content: flex-end;
      margin: 30px 0 32px;
      img {
        width: 248px;
        height: 100%;
        margin-right: calc(6vw + 80px);
      }
    }
  }

  .login-footer {
    position: absolute;
    bottom: 35px;
    left: 0;
    width: 100%;
    // padding: 0 20px;
    // margin: 50px auto;
    text-align: center;
    color: #86909c;
    font-size: 12px;
    z-index: 0;

    .provision {
      color:#4285f5;
      text-decoration: underline;
    }
  }
}
@media (max-width: 1669px) and (min-width: 1551px) {
  .login-container {
    .login-main {
      right: 18%;
    }
  }
}
@media (max-width: 1550px) and (min-width: 1301px) {
  .login-container {
    .login-main {
      right: 15%;
    }
  }
}
@media (max-width: 1300px) and (min-width: 991px) {
  .login-container {
    .login-main {
      right: 6%;
    }
  }
}
@media (max-width: 990px) and (min-width: 601px) {
  .login-container {
    .login-main {
      right: 1%;
    }
  }
}
@media (max-width: 600px) {
  .login-container {
    .login-main {
      right: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }
}
</style>
